<template>
	<div>
		<Filters :set_upcoming_notices="set_upcoming_notices"></Filters>
		<div v-if="!filters_applied" class="alert alert-danger" role="alert">
			{{ $t('no-filters') }}
		</div>
		<GmapMap :center="centre" :zoom="zoom" style="width: 100%; height: 600px" ref="map" class="box" :class="{'loading': loading }">
			<gmap-info-window 
				:position="info_position" 
				:opened="info_opened" 
				@closeclick="info_opened=false" 
				:options="info_options">

				<div class="container-fluid" style="width: 300px;">

				<h6>{{ current_marker.notice_id }}</h6>
					<div class="row">
						<div class="col-6"><strong>{{ $t('keys.notice_type')}}</strong>:</div>
						<div class="col-6">{{ current_marker.notice_type }}</div>
					</div>
					<div class="row" v-if="current_marker.meeting_date">
						<div class="col-6"><strong>{{ $t('keys.meeting_date')}}</strong>:</div>
						<div class="col-6">{{ current_marker.meeting_date | moment("YYYY-MM-DD") }}</div>
					</div>
					<div class="row" v-if="current_marker.address">
						<div class="col-6"><strong>{{ $t('keys.address')}}</strong>:</div>
						<div class="col-6">{{ current_marker.address }}</div>
					</div>
					<button class="btn btn-primary btn-sm mt-2" @click="detail(current_marker)">{{ $t('view-more-details') }}</button>
				</div>
			</gmap-info-window>
			<GmapMarker 
				v-for="(m,index) in markers"
				:key="index"
				:position="m.position"
				:clickable="true"
				@click="open_info_window(m,index)"
			/>

		</GmapMap>			
	</div>
</template>

<script>

import Filters from '@/components/Filters'
import { mapGetters, mapMutations } from 'vuex'

import {gmapApi} from 'vue2-google-maps'
import OpenData from '@/libraries/OpenData'
import { type } from 'os'

const WINNIPEG_CENTRE = {lat: 49.895495, lng: -97.138465};

	export default {
		data() {
			return {
				notices: [],
				zoom: 11,
				centre: WINNIPEG_CENTRE,
				info_opened: false,
				info_position: WINNIPEG_CENTRE,
				info_index: null,
				current_marker: {},
				info_options: {
					pixelOffset: {
						width: 0,
						height: -35
					}
				},
				set_upcoming_notices: false,
				loading: false,
			}
		},
		created() {
			if (!this.filters_applied) {
				this.set_upcoming_notices = true;
			} else {
				this.fetch();
			}
		},

		components: { Filters },

		watch: {
			parameters() {
				this.fetch();
			}
		},

		computed: {
			...mapGetters([
				'filters','offset','limit','sort'
			]),

			filters_applied() {
				return (this.filters.length > 0);
			},

			order_parameters() {
				return [{key: 'in_date', direction: 'DESC'}];
			},

			parameters() {
				let where_parameters = JSON.parse(JSON.stringify(this.filters));
				where_parameters.push([{column: 'location', type: 'NOTNULL' }]);
				let order_parameters = this.order_parameters;
				//const limit_parameters = { limit: 50 };
				//return { where_parameters, limit_parameters };
				return { where_parameters, order_parameters };
			},

			markers() {
				return this.notices.map(notice => {
					notice.position = {lat: parseFloat(notice.location.latitude), lng: parseFloat(notice.location.longitude) };
					return notice;
				}).filter(notice => typeof notice.position.lat === "number" && typeof notice.position.lng === "number" );
			},
		},

		methods: {
			...mapMutations([
				'set_filters','set_offset','set_limit','set_sort'
			]),

			detail(notice) {
				this.$router.push({name: 'Detail', params: { id: notice.notice_type + '-' + notice.notice_id }});
			},

			async fetch() {
				const params = this.parameters;
				this.loading = true;
				const data = await OpenData.getResults(this.$PUBLIC_NOTICES_API,params);
				this.notices = data;
				this.loading = false;
			},

			open_info_window(marker) {
				this.info_position = marker.position;
				this.current_marker = marker;
				this.info_opened = true;
			}
		},
	}
</script>

<style >
.loading {
	opacity: 0.5;
}

</style>